<template>
  <div id="app">
    <custom-header></custom-header>
    <main>
      <router-view></router-view>
    </main>
    <custom-footer></custom-footer>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'app',
  components: {
    'custom-header': Header,
    'custom-footer': Footer
  }
}
</script>

<style>
  @font-face {
    font-family: 'RubicRegular';
    src: url('/static/fonts/Rubik-Regular.ttf');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'RubicLight';
    src: url('/static/fonts/Rubik-Light.ttf');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'RubicMedium';
    src: url('/static/fonts/Rubik-Medium.ttf');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  *:focus {
    outline: none;
  }
  html {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }
  body {
    font-family: 'RubicLight', sans-serif;
    color: #e5e5e5;
    font-size: 19px;
    line-height: 27px;
    margin: 0;
    overflow-x: hidden;
  }
  img {
    max-width: 100%;
  }
  p {
    margin-bottom: 1em;
  }
  a,
  a:hover {
    color: #2190f7;
    cursor: pointer;
  }
  button:active {
    outline: none !important;
  }
  button:hover {
    outline: none !important;
  }
  button:focus {
    outline: none !important;
    box-shadow: none !important
  }
  #app {
    font-family: 'RubicLight', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #e5e5e5;
  }
  #app .tachyon-container {
    width: 90%;
    max-width: 1170px;
    margin-left: auto;
    margin-right: auto;
  }
  #app ul {
    list-style-type: none;
  }
  #app .blue-text {
    color: #0085ff;
  }
  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .5s ease;
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateY(-10px);
    opacity: 0;
  }
  .v-lazy-image {
    filter: blur(10px);
    transition: filter 0.7s;
  }
  .v-lazy-image-loaded {
    filter: blur(0);
  }
</style>



// WEBPACK FOOTER //
// src/App.vue